var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onDeselect}},_vm._l((_vm.flow.steps),function(step,i){return _c('FlowStepV2',{key:'ds' + i,attrs:{"step":step,"selected":_vm.selectedIndex == i},on:{"clicked":function($event){return _vm.onSelectStep(i)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }